import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Audience } from '../../audience/components/audience.model';

// Renders audiences_list results as clickable rows; clicking one opens the audience flyout (the
// panel handles the open). Opening a flyout is a read action, so there's no stale-click gating.
@Component({
  selector: 'app-agent-audience-list',
  templateUrl: './agent-audience-list.component.html',
  styleUrls: ['./agent-audience-list.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentAudienceListComponent {
  readonly audiences = input.required<Audience[]>();
  readonly openAudience = output<Audience>();
}
